import React from 'react';
import { Controller } from 'react-hook-form';
import { MenuItem, TextField, Typography } from '@mui/material';
import { productStatuses } from '../../data/statuses';

const FieldProductStatus = ({ control, name, label, rules, disabled }) => {
  return (
    <Controller
      name={name}
      defaultValue={''}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label}
          variant="filled"
          select
          fullWidth
          disabled={disabled}
        >
          {productStatuses.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
            >
              {/*<ListItemIcon color={option.color}>{option.icon}</ListItemIcon>*/}
              <Typography variant="inherit">{option.name}</Typography>
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};

export default FieldProductStatus;
